export const queries = [
    {
        name:'Muhammed Ali',
        avatar:'/images/avatars/Vector-12.png',
        excerpt:`Aliquid, adipisci delectus fugiat vero nemo repellat
        voluptatibus labore, consectetur adipisicing elit odit tenetur recusandae. Id, itaque.`,
    },
    {
        name:'Barry Allan',
        avatar:'/images/avatars/Vector-13.png',
        excerpt:`Lorem ipsum dolor sit amet consectetur adipisicing elit. Laudantium, placeat nam blanditiis ullam quae incidunt
        odio`,
    },
    {
        name:'Cisco Ramon',
        avatar:'/images/avatars/Vector-11.png',
        excerpt:`Ab tempore sint autem consectetur. Iure officiis quam obcaecati, consectetur adipisicing elit deleniti sequi aut quaerat, recusandae quasi nemo est delectus reprehenderit quos ducimus ad fugiat qui amet provident`,
    },
    {
        name:'Patrice Jane',
        avatar:'/images/avatars/Vector-8.png',
        excerpt:`Consectetur adipisicing elit neque culpa omnis nihil!`,
    }
]